import React from 'react';

const UserDataContext = React.createContext({isUserVerified: false})

export default UserDataContext;